/** Mic input level, sampled at 10 Hz (not per animation frame — this is chrome, not media). */
import { useEffect, useState } from 'react';

const SAMPLE_MS = 100;

export function useMicLevel(stream: MediaStream | null): number {
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (!stream || stream.getAudioTracks().length === 0) {
      setLevel(0);
      return;
    }
    const AudioCtor = window.AudioContext;
    if (!AudioCtor) return;

    const context = new AudioCtor();
    const analyser = context.createAnalyser();
    analyser.fftSize = 256;
    const source = context.createMediaStreamSource(stream);
    source.connect(analyser);
    const buffer = new Uint8Array(analyser.frequencyBinCount);

    const timer = window.setInterval(() => {
      analyser.getByteTimeDomainData(buffer);
      let peak = 0;
      for (const sample of buffer) peak = Math.max(peak, Math.abs(sample - 128) / 128);
      setLevel(Math.min(1, peak * 1.6));
    }, SAMPLE_MS);

    return () => {
      window.clearInterval(timer);
      source.disconnect();
      void context.close().catch(() => undefined);
    };
  }, [stream]);

  return level;
}
